module.exports = __webpack_public_path__ + "static/media/jamminforjonah.6517c06d.png";